import {
  createBrowserRouter,
  Outlet,
  Route,
  RouterProvider,
  Routes,
} from 'react-router';

import '@iwoca/orion/css/colors.css';
import '@iwoca/orion/css/radii.css';
import '@iwoca/orion/css/shadows.css';
import '@iwoca/orion/css/text.css';
import '@iwoca/orion/css/spacers.css';
import '@iwoca/orion/lib/css/orion.css';
import '@iwoca/login/dist/login.css';
import 'react-loading-skeleton/dist/skeleton.css';
import { AppWrapper } from './AppWrapper';
import {
  CHECKOUT_BASE_PATH,
  CheckoutRoutes,
  SECURITY_CHECKS_BASE_PATH,
  SecurityCheckRoutes,
} from './Buyer/Checkout/routes';
import { SIGNUP_BASE_PATH, SignupRoutes } from './Buyer/Signup/routes';
import { useOnMount } from './hooks/useOnMount';
import { PageNotFound } from './Pages/PageNotFound/PageNotFound';
import { routes } from './routing/app.routes';
import { initialise } from './utils/tracking';

type TFSUserVars = Record<string, number | boolean | string>;
declare global {
  interface Window {
    FS?: {
      setUserVars: (values: TFSUserVars) => void;
      identify: (id: string, values?: TFSUserVars) => void;
    };
  }
}

export const Root = () => {
  return (
    <Routes>
      <Route
        element={
          <AppWrapper>
            <div className="min-h-screen w-full bg-app-gradient text-center">
              <Outlet />
            </div>
          </AppWrapper>
        }
      >
        {/* These routes are complex and use a different set of routing rules - they will be removed soon  */}
        <Route path={`${SIGNUP_BASE_PATH}*`} element={<SignupRoutes />} />
        <Route path={`${CHECKOUT_BASE_PATH}/*`} element={<CheckoutRoutes />} />
        <Route
          path={`${SECURITY_CHECKS_BASE_PATH}/*`}
          element={<SecurityCheckRoutes />}
        />
        <Route path="/pay/*" element={<PageNotFound />} />
      </Route>
    </Routes>
  );
};

const browserRouter = createBrowserRouter([
  ...routes,
  { path: '*', element: <Root /> },
]);

export function App({ router = browserRouter }) {
  useOnMount(() => {
    initialise();
  });

  return <RouterProvider router={router} />;
}
